import {ExplytStoreItem} from "./ExplytStoreItem";

const fiftyTestCredits = <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2014_12194)">
        <rect width="40" height="40" fill="#212121"/>
        <path d="M15.7412 25.1846C13.7725 25.1846 12.3301 23.9814 12.2412 22.2588H13.7041C13.8135 23.2363 14.6543 23.9062 15.7549 23.9062C16.999 23.9062 17.8604 23.0381 17.8604 21.8008C17.8604 20.5635 16.999 19.6748 15.7686 19.6748C14.9141 19.6748 14.1758 20.0645 13.793 20.7139H12.3916L12.9111 15.1357H18.7832V16.4277H14.1416L13.8682 19.4561H13.9023C14.333 18.834 15.1396 18.458 16.1035 18.458C17.9971 18.458 19.3574 19.8457 19.3574 21.7598C19.3574 23.7832 17.8672 25.1846 15.7412 25.1846ZM24.1973 25.1846C21.832 25.1846 20.4307 23.2021 20.4307 20.0576C20.4307 16.9336 21.8457 14.9512 24.1973 14.9512C26.5557 14.9512 27.9502 16.9268 27.9502 20.0508C27.9502 23.1953 26.5625 25.1846 24.1973 25.1846ZM24.1973 23.8994C25.6055 23.8994 26.4053 22.4434 26.4053 20.0576C26.4053 17.7061 25.5918 16.2363 24.1973 16.2363C22.8027 16.2363 21.9824 17.7129 21.9824 20.0576C21.9824 22.4365 22.7891 23.8994 24.1973 23.8994Z" fill="#35C170"/>
    </g>
    <defs>
        <clipPath id="clip0_2014_12194">
            <rect width="40" height="40" rx="8" fill="white"/>
        </clipPath>
    </defs>
</svg>


const oneHundredTestCredits = <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2014_14714)">
        <rect width="40" height="40" fill="#212121"/>
        <path d="M11.3389 25V16.6533H11.3047L8.72754 18.4854V16.9814L11.3252 15.1357H12.8359V25H11.3389ZM18.8379 25.1846C16.4727 25.1846 15.0713 23.2021 15.0713 20.0576C15.0713 16.9336 16.4863 14.9512 18.8379 14.9512C21.1963 14.9512 22.5908 16.9268 22.5908 20.0508C22.5908 23.1953 21.2031 25.1846 18.8379 25.1846ZM18.8379 23.8994C20.2461 23.8994 21.0459 22.4434 21.0459 20.0576C21.0459 17.7061 20.2324 16.2363 18.8379 16.2363C17.4434 16.2363 16.623 17.7129 16.623 20.0576C16.623 22.4365 17.4297 23.8994 18.8379 23.8994ZM27.5605 25.1846C25.1953 25.1846 23.7939 23.2021 23.7939 20.0576C23.7939 16.9336 25.209 14.9512 27.5605 14.9512C29.9189 14.9512 31.3135 16.9268 31.3135 20.0508C31.3135 23.1953 29.9258 25.1846 27.5605 25.1846ZM27.5605 23.8994C28.9688 23.8994 29.7686 22.4434 29.7686 20.0576C29.7686 17.7061 28.9551 16.2363 27.5605 16.2363C26.166 16.2363 25.3457 17.7129 25.3457 20.0576C25.3457 22.4365 26.1523 23.8994 27.5605 23.8994Z" fill="#35C170"/>
    </g>
    <defs>
        <clipPath id="clip0_2014_14714">
            <rect width="40" height="40" rx="8" fill="white"/>
        </clipPath>
    </defs>
</svg>

const twoHundredTestCredits = <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2014_14701)">
        <rect width="40" height="40" fill="#212121"/>
        <path d="M7.90723 18.0273C7.90723 16.25 9.33594 14.9512 11.2979 14.9512C13.1777 14.9512 14.5791 16.1475 14.5791 17.7129C14.5791 18.8613 13.9639 19.7158 12.5215 21.1924L10.0537 23.6738V23.708H14.7363V25H7.98926V23.9609L11.5508 20.3311C12.7539 19.0801 13.0684 18.5605 13.0684 17.7881C13.0684 16.9131 12.2754 16.2158 11.25 16.2158C10.1699 16.2158 9.35645 16.9951 9.35645 18.0205V18.041H7.90723V18.0273ZM19.6924 25.1846C17.3271 25.1846 15.9258 23.2021 15.9258 20.0576C15.9258 16.9336 17.3408 14.9512 19.6924 14.9512C22.0508 14.9512 23.4453 16.9268 23.4453 20.0508C23.4453 23.1953 22.0576 25.1846 19.6924 25.1846ZM19.6924 23.8994C21.1006 23.8994 21.9004 22.4434 21.9004 20.0576C21.9004 17.7061 21.0869 16.2363 19.6924 16.2363C18.2979 16.2363 17.4775 17.7129 17.4775 20.0576C17.4775 22.4365 18.2842 23.8994 19.6924 23.8994ZM28.415 25.1846C26.0498 25.1846 24.6484 23.2021 24.6484 20.0576C24.6484 16.9336 26.0635 14.9512 28.415 14.9512C30.7734 14.9512 32.168 16.9268 32.168 20.0508C32.168 23.1953 30.7803 25.1846 28.415 25.1846ZM28.415 23.8994C29.8232 23.8994 30.623 22.4434 30.623 20.0576C30.623 17.7061 29.8096 16.2363 28.415 16.2363C27.0205 16.2363 26.2002 17.7129 26.2002 20.0576C26.2002 22.4365 27.0068 23.8994 28.415 23.8994Z" fill="#35C170"/>
    </g>
    <defs>
        <clipPath id="clip0_2014_14701">
            <rect width="40" height="40" rx="8" fill="white"/>
        </clipPath>
    </defs>
</svg>

export function resolveItemImage(iconType: string) {
    switch (iconType) {
        case "FiftyTestTokens": return fiftyTestCredits;
        case "OneHundredTestTokens": return oneHundredTestCredits
        case "TwoHundredTestTokens": return twoHundredTestCredits;
    }
    // Fallback...
    return fiftyTestCredits;
}

export function resolvePrice(itemType: string) : number {
    switch (itemType) {
        case "FiftyTestTokens": return 50;
        case "OneHundredTestTokens": return 100
        case "TwoHundredTestTokens": return 200;
    }
    // Fallback...
    return 9999;
}

export function itemOfType(t: (_: string) => string, itemType : string) : ExplytStoreItem {
    return {
        id: itemType,
        imageElement: resolveItemImage(itemType),
        name: t(itemType),
        description: t(`${itemType}Description`),
        price: resolvePrice(itemType),
        currency: "Credits"
    }
}